module.exports = __webpack_public_path__ + "components/flag/static/square/gb-nir-3aaf8114b2d55584102bc0da908b5312.svg";